import { useState } from "react";
import { toastr } from "react-redux-toastr";
import QRCode from "qrcode";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";
import Loader from "react-loader-spinner";
import { Field, reduxForm } from "redux-form";
import { Button, Input } from "expano-components";
import { Modal } from "components";
import { StickerProductPackage } from "sticker_templates";
import { ReactComponent as Sticker } from "icons/sticker.svg";

const InputField = (props) => <Input {...props} />;

const validate = (values) => {
  const errors = {};
  if (!values.quantity) {
    errors.validate = "Pole wymagane!";
  } else if (isNaN(Number(values.quantity))) {
    errors.quantity = "Musi być liczbą!";
  } else if (Number(values.quantity) < 1) {
    errors.quantity = "Wartość musi byc wieksza od 0!";
  }
  return errors;
};

const convertWebpToPngBase64 = async (url) => {
  const img = new Image();
  img.crossOrigin = "Anonymous";
  img.src = url;

  await new Promise((res, rej) => {
    img.onload = res;
    img.onerror = rej;
  });

  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  return canvas.toDataURL("image/png"); // zwraca poprawny base64 PNG z nagłówkiem
};

const ProductPackageStickerModal = ({
  data,
  invalid,
  handleSubmit,
  handleClose,
}) => {
  const [is_loading, setLoading] = useState(false);

  const submit = async ({ quantity }) => {
    try {
      setLoading(true);
      if (!data.sku) {
        throw new Error("Brak sku produktu.");
      }

      const qr_code_base64 = await QRCode.toDataURL(data.sku);

      if (!qr_code_base64) {
        throw new Error("Błąd generowania kodu qr.");
      }

      if (!data.image_thumb_url) {
        throw new Error("Brak zdjęcia produktu.");
      }
      const image_base64 = await convertWebpToPngBase64(data.image_thumb_url);
      const blob = await pdf(
        <StickerProductPackage
          data={{
            sku: data.sku,
            name: data.name,
            quantity: Number(quantity),
            image_base64,
            qr_code_base64,
          }}
        />
      ).toBlob();
      saveAs(blob, `${data?.sku}-package.pdf`);
      handleClose();
    } catch (error) {
      toastr.error("Błąd", error?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Modal
      header={{ title: "Naklejki na paczkę", icon: <Sticker /> }}
      footer={
        <>
          <Button type="cancel" text="Anuluj" onClick={handleClose} />
          <Button
            type="save"
            text={
              is_loading ? (
                <Loader type="Oval" color="#fff" height={15} width={15} />
              ) : (
                "Pobierz"
              )
            }
            disabled={is_loading || invalid}
            onClick={handleSubmit(submit)}
          />
        </>
      }
      handleClose={handleClose}
    >
      <form noValidate>
        <div className="row">
          <div className="box-12">
            <Field
              label="Ilość"
              name="quantity"
              type="number"
              component={InputField}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default reduxForm({
  form: "qr-code-sticker",
  validate,
  enableReinitialize: true,
})(ProductPackageStickerModal);
